/* istanbul ignore file  -- query */
import { gql } from '@ori/fetching';

export const topAreaBanners = gql`
  query TopAreaBanners($bannerType: PermanentTopBannerType!) {
    application {
      permanentTopBanners(bannerType: $bannerType) {
        message
        link {
          id
          title
          relativeUrl
        }
      }
    }
  }
`;
